import get from 'lodash/get';
import isEmpty from 'lodash/isEmpty';
import set from 'lodash/set';

// TODO find a better place for this
// transforms using this config are not persisted in db and currently only for preview
export const APP_TRANSFORM_CONFIG = {
  'CardBannerPlacement - App': [
    { target: 'ComponentName', value: 'preview' },
    { source: 'Id', target: 'Id' },
    { target: 'SchemaName', value: 'Tile' },
    {
      source: 'bannerContent.phoneImageURL',
      target: 'ImageLink.MobileImage_Url.ImageUrl'
    },
    {
      source: 'bannerContent.phoneImageURL',
      target: 'ImageLink.MobileImage_Url.AltText'
    },
    {
      source: 'bannerContent.tabletImageURL',
      target: 'ImageLink.Image_Url.ImageUrl'
    },
    {
      source: 'bannerContent.tabletImageURL',
      target: 'ImageLink.Image_Url.AltText'
    },
    {
      source: 'bannerContent.liveText',
      target: 'CopySet[0].LiveText'
    }
  ],
  'Dash Hudson Gallery - App': [
    { target: 'ComponentName', value: 'preview' },
    { source: 'Id', target: 'Id' },
    { target: 'SchemaName', value: 'Tile' },
    {
      source: 'headline',
      target: 'CopySet[0].Heading[0].HeadlineLiveText'
    },
    {
      source: 'liveText',
      target: 'CopySet[0].LiveText'
    },
    {
      target: 'CopySet[0].TextJustification',
      value: 'Center'
    }
  ],
  'Event Banner': [
    { target: 'ComponentName', value: 'preview' },
    { source: 'Id', target: 'Id' },
    { target: 'SchemaName', value: 'Tile' },
    {
      source: 'banner.phoneBgImageURL',
      target: 'ImageLink.MobileImage_Url.ImageUrl'
    },
    {
      source: 'banner.phoneBgImageURL',
      target: 'ImageLink.MobileImage_Url.AltText'
    },
    {
      source: 'banner.tabletBgImageURL',
      target: 'ImageLink.Image_Url.ImageUrl'
    },
    {
      source: 'banner.tabletBgImageURL',
      target: 'ImageLink.Image_Url.AltText'
    },
    {
      source: 'banner.heading',
      target: 'CopySet[0].Heading[0].HeadlineLiveText'
    }
  ],
  'HomePagePlacement - App': [
    { target: 'ComponentName', value: 'preview' },
    { source: 'Id', target: 'Id' },
    { target: 'SchemaName', value: 'Tile' },

    // mock assets based on homePagePlacementType value
    // shoppingBag
    {
      target: 'ImageLink.MobileImage_Url.ImageUrl',
      value: {
        dependsOn: 'homePagePlacementType',
        match: 'shoppingBag',
        value:
          'https://n.integ.nordstrommedia.com/id/8833b0dd-8256-41a4-ae1b-61f5b8f068d9.png?h=278&w=276'
      }
    },

    // wishlist
    {
      target: 'ImageLink.MobileImage_Url.ImageUrl',
      value: {
        dependsOn: 'homePagePlacementType',
        match: 'wishlist',
        value:
          'https://n.integ.nordstrommedia.com/id/68ff1192-9553-478a-bb40-687829d9843b.png?h=278&w=276'
      }
    },

    // jumpBackIn
    {
      target: 'ImageLink.MobileImage_Url.ImageUrl',
      value: {
        dependsOn: 'homePagePlacementType',
        match: 'jumpBackIn',
        value:
          'https://n.integ.nordstrommedia.com/id/a10e92ea-5a35-4472-a3b6-04b7335e185a.png?h=278&w=452'
      }
    },

    // loyalty
    {
      target: 'ImageLink.MobileImage_Url.ImageUrl',
      value: {
        dependsOn: 'homePagePlacementType',
        match: 'loyalty',
        value:
          'https://n.integ.nordstrommedia.com/id/8a898e77-36e7-4f10-80b9-56e5d6c8c16a.png?h=278&w=274'
      }
    },

    // orderStatus
    {
      target: 'ImageLink.MobileImage_Url.ImageUrl',
      value: {
        dependsOn: 'homePagePlacementType',
        match: 'orderStatus',
        value:
          'https://n.integ.nordstrommedia.com/id/50d906f0-2ffc-4d18-bc29-76d86207765c.png?h=278&w=748'
      }
    },

    // departments
    {
      target: 'ImageLink.MobileImage_Url.ImageUrl',
      value: {
        dependsOn: 'homePagePlacementType',
        match: 'departments',
        value:
          'https://n.nordstrommedia.com/id/9671976c-d142-46a2-a8fb-109133964f21.png?h=278&w=814'
      }
    },

    // copy indicator
    {
      target: 'CopySet[0].Heading[0].HeadlineLiveText',
      value: 'HomePagePlacement - App'
    },
    {
      target: 'CopySet[0].Heading[0].HeadlineLiveTextSize',
      value: 'Medium'
    },
    {
      source: 'homePagePlacementType',
      target: 'CopySet[0].LiveText'
    },
    {
      target: 'CopySet[0].TextJustification',
      value: 'Center'
    }
  ],
  'Image Only - App': [
    { target: 'ComponentName', value: 'preview' },
    { source: 'Id', target: 'Id' },
    { target: 'SchemaName', value: 'Tile' },
    { target: 'Variation', value: 'Image Only' },
    {
      source: 'phoneImageURL',
      target: 'ImageLink.MobileImage_Url.ImageUrl'
    },
    {
      source: 'phoneImageURL',
      target: 'ImageLink.MobileImage_Url.AltText'
    },
    {
      source: 'tabletImageURL',
      target: 'ImageLink.Image_Url.ImageUrl'
    },
    {
      source: 'tabletImageURL',
      target: 'ImageLink.Image_Url.AltText'
    },
    {
      source: 'targetURL',
      target: 'ImageLink.LinkURL'
    }
  ],
  'New Feature Banner - App': [
    { target: 'ComponentName', value: 'preview' },
    { source: 'Id', target: 'Id' },
    { target: 'SchemaName', value: 'Tile' },
    { target: 'Variation', value: 'Copy Only' },
    {
      source: 'Header',
      target: 'CopySet[0].Heading[0].HeadlineLiveText'
    },
    {
      source: 'Description',
      target: 'CopySet[0].LiveText'
    }
  ],
  'Recommendations - App': [
    { target: 'ComponentName', value: 'preview' },
    { source: 'Id', target: 'Id' },
    { target: 'SchemaName', value: 'Recommendations 3.0' },
    { target: 'placement', value: 'HP_APP' }
  ],
  'Responsive Carousel - App': [
    { target: 'ComponentName', value: 'preview' },
    { source: 'Id', target: 'Id' },
    { target: 'SchemaName', value: 'Responsive Carousel' },
    {
      isChildrenArray: true,
      source: 'heroCarouselItems',
      target: 'tiles'
    },
    { source: 'carouselHeadline', target: 'headlineLiveText' }
  ],

  'NRHL Tile': [
    { target: 'ComponentName', value: 'preview' },
    { source: 'Id', target: 'Id' },
    { target: 'SchemaName', value: 'Tile' },
    { target: 'Variation', value: 'Tile' },
    {
      source: 'mobileImageUrl',
      target: 'ImageLink.MobileImage_Url.ImageUrl'
    },
    {
      source: 'tabletImageUrl',
      target: 'ImageLink.Image_Url.ImageUrl'
    },
    {
      source: 'copyHeading',
      target: 'CopySet[0].Heading[0].HeadlineLiveText'
    },
    {
      source: 'copyText',
      target: 'CopySet[0].LiveText'
    },
    {
      source: 'TextJustification',
      target: 'CopySet[0].TextJustification'
    },

    /* NOTE: 
    {
      source: 'Links[*].linkText',
      target: 'CopySet[0].Links[*].Text'
    }
    The above configuration (using *) is breaking the preview,
    hardcoding the index is a temp workaround to unblock NRHL.
    */
    {
      source: 'Links[0].linkText',
      target: 'CopySet[0].Links[0].Text'
    },
    {
      source: 'Links[1].linkText',
      target: 'CopySet[0].Links[1].Text'
    },
    {
      source: 'Links[2].linkText',
      target: 'CopySet[0].Links[2].Text'
    },
    {
      source: 'Links[3].linkText',
      target: 'CopySet[0].Links[3].Text'
    },
    {
      source: 'Links[0].linkURL',
      target: 'CopySet[0].Links[0].LinkURL'
    },
    {
      source: 'Links[1].linkURL',
      target: 'CopySet[0].Links[1].LinkURL'
    },
    {
      source: 'Links[2].linkURL',
      target: 'CopySet[0].Links[2].LinkURL'
    },
    {
      source: 'Links[3].linkURL',
      target: 'CopySet[0].Links[3].LinkURL'
    }
  ],

  // NOTE app tile also supports tab content and is not currently previewed
  'Tile - App': [
    { target: 'ComponentName', value: 'preview' },
    { source: 'Id', target: 'Id' },
    { target: 'SchemaName', value: 'Tile' },
    { target: 'Variation', value: 'Tile' },
    {
      source: 'storyContents.headlineLiveText',
      target: 'CopySet[0].Heading[0].HeadlineLiveText'
    },
    {
      source: 'storyContents.liveText',
      target: 'CopySet[0].LiveText'
    },
    {
      source: 'storyContents.phoneImageURL',
      target: 'ImageLink.MobileImage_Url.ImageUrl'
    },
    {
      source: 'storyContents.phoneImageURL',
      target: 'ImageLink.MobileImage_Url.AltText'
    },
    {
      source: 'storyContents.tabletImageURL',
      target: 'ImageLink.Image_Url.ImageUrl'
    },
    {
      source: 'storyContents.tabletImageURL',
      target: 'ImageLink.Image_Url.AltText'
    }
  ]
};

/**
 * recursion helper for `transform`
 *
 * @param {object} params - function params
 * @param {object} params.srcData - source data for transforma
 * @param {string[]} params.srcParts - property path within srcData to read input data
 * @param {object} params.tgtData - target data for transform
 * @param {string[]} params.tgtParts - property path within tgtData to write output data
 * @param {string[]} [params.depParts] - property path within tgtData to read dependency values
 * @returns {object} data after transform
 */
const recursiveTransform = function recursiveTransformHelper({
  srcData,
  srcParts,
  tgtData = {},
  tgtParts,
  depParts
}) {
  const MISSING_PLACEHOLDER = '###';

  if (srcParts.length === 1) {
    const isMissingDeps = depParts && !get(tgtData, depParts[0]);
    const val = get(srcData, srcParts[0], MISSING_PLACEHOLDER);

    return isMissingDeps || isEmpty(val) || val === MISSING_PLACEHOLDER
      ? tgtData
      : set(tgtData, tgtParts[0], val);
  }

  return get(srcData, srcParts[0], []).reduce(
    (acc, cur, ind) =>
      set(
        acc,
        [...tgtParts[0].split('.'), ind],
        recursiveTransform({
          depParts: depParts && depParts.slice(1),
          srcData: cur,
          srcParts: srcParts.slice(1),
          tgtData: get(acc, [...tgtParts[0].split('.'), ind]),
          tgtParts: tgtParts.slice(1)
        })
      ),
    tgtData
  );
};

/**
 * transform given payload according to given config
 *
 * @param {object} params - function params
 * @param {object} params.config - config of transforms
 * @param {object} params.payload - payload to transform
 * @returns {object} transformed payload
 */
export const transform = function recursiveTransformRunner({ config, payload }) {
  const transforms = config[payload.SchemaName];
  if (!transforms) {
    return payload;
  }

  const arrayIndicator = '[*].';
  const shaped = transforms.reduce(
    (acc, { dependsOn, isChildrenArray, source, target, value }) => {
      if (isChildrenArray) {
        return set(
          acc,
          target,
          get(payload, source, []).map(child => transform({ config, payload: child }))
        );
      }

      if (value) {
        const isValueObject = typeof value === 'object';
        if (isValueObject && get(payload, value.dependsOn) !== value.match) {
          return acc;
        }

        return set(acc, target, isValueObject ? value.value : value);
      }

      return recursiveTransform({
        depParts: dependsOn && dependsOn.split(arrayIndicator),
        srcData: payload,
        srcParts: source.split(arrayIndicator),
        tgtData: acc,
        tgtParts: target.split(arrayIndicator)
      });
    },
    {}
  );

  // TODO remove empty objects
  return shaped;
};
